// extracted by mini-css-extract-plugin
module.exports = {"card":"ForgotPasswordForm_card__mDPrI"};